import { supabase } from './supabaseClient';

/* ══ Auth helpers ══════════════════════════════════════════════════
   Roles are never decided on the client: every user gets a
   `profiles` row (role='user') via a DB trigger on signup, and only
   an existing admin can promote someone to role='admin' (see
   supabase/migrations/0001_init.sql). We simply read that role back
   after login. ══ */

export async function fetchProfile(userId) {
  const { data, error } = await supabase
    .from('profiles')
    .select('email, name, role')
    .eq('id', userId)
    .single();
  if (error) throw error;
  return data;
}

export async function signInWithPassword(email, password) {
  const { data, error } = await supabase.auth.signInWithPassword({
    email,
    password,
  });
  if (error) throw error;
  return data;
}

export async function signUpWithPassword(email, password, name) {
  const { data, error } = await supabase.auth.signUp({
    email,
    password,
    options: { data: { name } },
  });
  if (error) throw error;
  return data;
}

export async function signInWithGoogle() {
  const { error } = await supabase.auth.signInWithOAuth({
    provider: 'google',
    options: { redirectTo: window.location.origin },
  });
  if (error) throw error;
}

export async function signOut() {
  const { error } = await supabase.auth.signOut();
  if (error) throw error;
}
